import { render, staticRenderFns } from "./VipForm.vue?vue&type=template&id=56e0a23f&scoped=true&"
import script from "./VipForm.vue?vue&type=script&lang=js&"
export * from "./VipForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e0a23f",
  null
  
)

export default component.exports